<template>
  <div v-wechat-title="$route.meta.title">
    <div class="cont">
      <!-- 搜索 -->
      <div class="search">
        <img @click="back" src="../assets/img/back.png" />
        <div class="searchCont">
          <van-search
            v-model="queryData.SalesOrderCode"
            placeholder="输入订单号/备注/车型信息检索"
            @search="getOrder"
          />
        </div>
        <img @click="handleShowModel" src="../assets/img/shaixuan.png" />
      </div>

      <div class="list list2">
        <van-notice-bar wrapable :scrollable="false" mode="closeable" @close="closeTip" v-if="showVinTip">
          车型：{{ OrderHistoryStore.VehicleType || "无" }} <br />
          VIN：{{ OrderHistoryStore.vin || "无" }}
        </van-notice-bar>
        <!-- 列表 -->
        <!-- <ul v-if="showList">
          <li v-for="(item, idx) of list" :key="idx">
            <div class="tag">智能报价</div>
            <div class="code">{{ item.OrderTypeText }}:{{ item.SalesOrderCode }}</div>
            <div class="van-hairline--bottom listBox" v-for="(at, x) of item.SalesOrderItemList" :key="x">
              <div class="van-multi-ellipsis--l2 title">{{ at.ProductTitle }}</div>
            </div>
            <div class="Aumout">
              <div>数量合计: {{ CountNum(item.SalesOrderItemList) }}</div>
              <div>￥{{ item.Amount | toFixedNum }}</div>
            </div>
            <div class="orderTime van-hairline--bottom">下单时间：{{ item.CreateTimeText }}</div>
            <div class="footer">
              <div class="van-hairline--surround" @click="handleToPage">查看单据处理情况</div>
              <div @click="handleToOrderDetail(item.Id)">查看详情</div>
            </div>
          </li>
        </ul> -->
        <van-list :finished="finished" :finished-text="empty ? '' : '没有更多了'" v-model="loading" @load="onLoad">
          <ul>
            <li v-for="(item, idx) of list" :key="idx">
              <div class="createTime">下单时间：{{ item.CreateTimeText | timeFormatYdTime }}</div>
              <div class="box">
                <div class="tag">智能报价</div>

                <div class="row flex">
                  <div>{{ item.OrderTypeText }}单号: {{ item.SalesOrderCode }}<span class="statusText">{{item.StatusText}}</span></div>
                </div>
                <div class="row flex" v-if="isType==1">
                  <div>客户名称: {{ customerName }}</div>
                </div>
                <div class="row border">
                  <div class="vin"><i class="icon vin"></i> VIN码：{{ item.vin || "无" }}</div>
                  <div class="VehicleTypeName"><i class="icon car"></i> {{ item.VehicleTypeName || "无" }}</div>
                </div>

                <div class="row" v-for="(at, x) of item.SalesOrderItemListSub" :key="'list2' + x">
                  <div class="proTitle">{{ at.ProductTitle }}</div>
                </div>

                <div class="row" v-if="item.more">……</div>
                <div class="row remark-box" v-if="item.Remark">
                  <div class="remark">备注:{{ item.Remark || "无" }}</div>
                </div>

                <div class="row flex">
                  <div class="count-info">
                    <div class="count">合计数量: <span class="red">{{ item.CountNum }} 个</span></div>
                    <div class="amount red">合计金额：￥{{ item.Amount | toFixedNum }}</div>
                  </div>
                </div>
                <div class="btns">
                  <van-button type="default" size="mini" @click="handleToOrderDetail(item.Id)">
                    {{item.SaleBillingnum>0?'已转结算':item.PayStatusText}}
                  </van-button>
                  <van-button type="default" size="mini" @click="share(item.Id,item.PayStatus)" v-if="isType==1">分享</van-button>
                  <van-button type="primary" color="#4FAE54" size="mini" @click="handleToOrderDetail(item.Id)">查看详情</van-button>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
        <!-- 数据为空 -->
        <div class="buyBlock" v-if="empty">
          <div class="buyBlockTop">
            <img src="../assets/icon/gouwuche.png" />
            <span class="buyBlockTxt">暂无历史订单</span>
          </div>
        </div>
      </div>

      <!-- 筛选 -->
      <van-popup position="right" :style="{ width: '85%', height: '100%' }" v-model="modelShow">
        <div class="model">
          <div class="times">
            <div class="it" @click="handleTime(1)">
              <span>{{ queryData.StartTime ? queryData.StartTime : "开始保存时间" }}</span>
              <img src="../assets/img/time.png" />
            </div>
            <div class="it" @click="handleTime(2)">
              <span>{{ queryData.EndTime ? queryData.EndTime : "开始结束时间" }}</span>
              <img src="../assets/img/time.png" />
            </div>
          </div>
          <div class="item">
            <div class="name">产品名称</div>
            <input v-model="queryData.ProductName" placeholder="请输入产品名称" />
          </div>
          <div class="item">
            <div class="name">型号</div>
            <input v-model="queryData.Model" placeholder="请输入产品型号" />
          </div>
          <div class="item">
            <div class="name">规格</div>
            <input v-model="queryData.Specifications" placeholder="请输入产品规格" />
          </div>
          <div class="item">
            <div class="name">厂商编码</div>
            <input v-model="queryData.BrandManufacturerCode" placeholder="请输入厂商编码" />
          </div>
          <div class="item">
            <div class="name">自定义车型</div>
            <input v-model="queryData.CustomModel" placeholder="请输入自定义车型" />
          </div>
          <div class="modelBtn">
            <div class="van-hairline--surround" @click="reset">重置</div>
            <div @click="handleSearch">查询</div>
          </div>
          <!-- 时间控件 -->
        </div>
      </van-popup>
      <van-popup position="bottom" :style="{ width: '100%', height: '36%' }" v-model="timeShow">
        <van-datetime-picker v-model="currentDate" type="date" :title="timeTitle" @confirm="confirm" @cancel="cancel" />
      </van-popup>
    </div>
    <template v-if="isShare">
      <div class="fixed-layer"></div>
      <div class="sharebg" @click="isShare = false"></div>
    </template>
  </div>
</template>
<script>
import Vue from "vue";
import { List, Popup, Search, DatetimePicker, Toast } from "vant";
import api from "../services/api";
import dayjs from "dayjs";
import OrderHistoryStore from "../store/orderHistory";
import util from "../utils/util";
Vue.use(List)
  .use(Popup)
  .use(Search)
  .use(DatetimePicker);
export default {
  name: "historicalOrders",
  data() {
    return {
      OrderHistoryStore,
      queryData: {
        VehicleTypeId: "",
        SalesOrderCode: "",
        ProductName: "",
        BrandManufacturerCode: "",
        Specifications: "",
        Model: "",
        CustomModel: "",
        StartTime: "",
        EndTime: "",
        pageNo: -1,
      },
      modelShow: false,
      timeShow: false,
      timeType: 1,
      currentDate: new Date(),
      timeTitle: "",
      list: [],
      pageShow: false,
      showVinTip: false,
      finished: false,
      loading: false,
      vanLoading: null,
      isType:1,
      orderId:0,
      isShare:false,
      payStatus:0,
      customerName:'',
    };
  },
  filters: {
    toFixedNum(val) {
      return Number(val).toFixed(2);
    },
    timeFormatYdTime(str) {
      return dayjs(str).format("YYYY/MM/DD HH:mm:ss");
    },
  },
  computed: {
    empty() {
      if (this.finished && this.list.length == 0) {
        return true;
      }
    },
    showList() {
      if (this.pageShow && this.list.length > 0) {
        return true;
      }
    },
  },
  watch: {
    // loading(val) {
    //   if (val) {
    //     Toast.loading({ message: "加载中...", duration: 0 });
    //   } else {
    //     Toast.clear();
    //   }
    // },
  },
  created() {
    if (this.$route.query.VehicleTypeId == OrderHistoryStore.VehicleTypeId) {
      //显示提示
      this.queryData.VehicleTypeId = OrderHistoryStore.VehicleTypeId;
      this.showVinTip = true;
    }
    this.isType = util.getStoObj('urlQuery').IsTypr;
    if(this.isType==1){
      this.customerName = sessionStorage.getItem("CustomerName");
    }
    this.orderId = this.$route.params.id
  },
  mounted(){
    // wx.miniProgram.postMessage({
    //   data: {
    //     shareUrl: "orderDetail/"+this.orderId,
    //     shareTitle: "订单详情",
    //     payStatus: this.payStatus,
    //     loginType:this.isType,
    //     customerName:this.customerName
    //   }
    // });
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    share(id,payStatus){

      this.orderId = id;
      console.log(this.orderId);
      this.isShare = true;
      this.payStatus = payStatus
      wx.miniProgram.postMessage({
        data: {
          shareUrl: "orderDetail/"+this.orderId,
          shareTitle: "订单详情",
          payStatus: this.payStatus,
          loginType:this.isType,
          customerName:this.customerName
        }
      });
    },
    closeTip() {
      OrderHistoryStore.VehicleTypeId = "";
      this.queryData.VehicleTypeId = "";
      this.queryData.pageNo = -1;
      this.finished = false;
      document.documentElement.scrollTop = 0;
      this.list = [];
      this.onLoad();
    },
    onLoad() {
      this.queryData.pageNo++;
      this.getList();
    },

    // 获取列表
    getList() {
      this.loading = true;
      api.historicalOrder(this.queryData).then((res) => {
        if (res.ResultType == 1) {
          this.loading = false;
          res.Data = res.Data || [];

          res.Data.map((it) => {
            it.SalesOrderItemListSub = it.SalesOrderItemList.slice(0, 3);
            it.CountNum = this.CountNum(it.SalesOrderItemList);
            it.more = it.SalesOrderItemList.length > 3;
          });

          if (res.Data.length === 0) {
            this.finished = true;
            return;
          }
          this.list.push(...res.Data);
          if (this.list.length >= res.Count) {
            this.finished = true;
          }
        }
      });
    },

    getOrder() {
      this.queryData.pageNo = -1;
      this.finished = false;
      this.list = [];
      document.documentElement.scrollTop = 0;
      this.onLoad();
    },
    // 查询
    handleSearch() {
      let startTime = this.queryData.StartTime;
      let endTime = this.queryData.EndTime;
      if (startTime && endTime) {
        if (!this.compareDate(startTime, endTime)) {
          return Toast("开始保存时间不能大于开始结束时间!");
        }
      }
      this.queryData.pageNo = -1;
      this.finished = false;
      document.documentElement.scrollTop = 0;
      this.list = [];
      this.onLoad();
      this.modelShow = false;
    },
    // 计算合计
    CountNum(list) {
      let num = 0;
      list.map((it) => {
        num = num + it.CountNum;
      });

      console.log(num);
      return num;
    },
    handleShowModel() {
      this.modelShow = true;
    },
    handleToOrderDetail(id) {
      this.$router.push(`/orderDetail/${id}`);
    },
    handleTime(type) {
      this.timeType = type;
      this.timeShow = true;
      type === 1 ? (this.timeTitle = "选择开始保存时间") : (this.timeTitle = "选择结束时间");
    },
    timeFormatYd(str) {
      return dayjs(str).format("YYYY/MM/DD");
    },

    // 比较时间大小
    compareDate(startTime, endTime) {
      return new Date(startTime.replace(/-/g, "\/")) <= new Date(endTime.replace(/-/g, "\/"));
    },
    handleToPage() {
      this.$router.push("/baojia");
    },
    confirm(value) {
      value = this.timeFormatYd(value);
      this.timeType === 1 ? (this.queryData.StartTime = value) : (this.queryData.EndTime = value);
      this.timeShow = false;
      this.currentDate = new Date();
    },
    cancel() {
      this.timeShow = false;
    },
    reset() {
      for (let key in this.queryData) {
        if (key === "VehicleTypeId") continue;
        if (key === "pageNo") continue;
        this.queryData[key] = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/historicalOrders.scss";
.fixed-layer {
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 1;
    -webkit-transition-duration: .3s;
    transition-duration: .3s;
    background: rgba(0, 0, 0, .4);
    z-index: 1000;
}
.btns{
  display: flex;
  justify-content: flex-end;
  padding:10px 10px 10px 0;
  border-top:1px solid #eee;
  align-items: center;
}
.statusText{
  color: #FF5A2E;
  background: #FDF0EC;
  border: 1px solid #FF5A2E;
  border-radius: 5px;
  font-size: 0.24rem;
  padding: 2px;
}
.sharebg {
    background: url(../assets/icon/share_bg.png) no-repeat right 0;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1001;
    top: 0;
    right: 1rem;
    display: block;
    background-size: 80% auto;
    z-index: 1000;
}
.list2 {
  .createTime {
    text-align: left;
    font-size: 0.28rem;
    padding: 0.2rem 0.2rem;
    background: #f6f6f6;
    color: #999;
  }
  .proTitle{
    height: 0.42rem;
    line-height: 0.42rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .box {
    font-size: 0.26rem;
    background: #fff;
    line-height: 0.42rem;

    .row.border {
      border-bottom: 1px #f2f2f2 solid;
      color: #666;
    }
    .icon {
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 1.5em;
      height: 1em;
      vertical-align: text-top;
      display: inline-block;
    }
    .icon.vin {
      background-image: url(../assets/shengji/vin.png);
    }

    .icon.car {
      background-image: url(../assets/shengji/car.png);
    }
    .row {
      padding: 0.05rem 0.2rem;
      .VehicleTypeName {
        color: #555;
      }
    }
    .count-info {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .remark-box {
      .remark {
        flex: 1;
        font-size: 0.18rem;
        color: #666;
      }
    }
    .red {
      color: #fd3939;
    }
    .amount {
      font-weight: bold;
    }
    .row.flex {
      display: flex;
      align-items: center;
      .date {
        text-align: right;
      }
    }
  }
}
</style>
<style>
.search .van-field__body .van-field__control {
  text-align: left !important;
}
</style>
